import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const SetupBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
`;

export const SetupRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SetupNote = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const SetupLink = styled(Link)`
  color: inherit;
  font-weight: 500;
  text-decoration: underline;
`;
